import { observer } from 'mobx-react-lite';
import { Fragment, SyntheticEvent, useEffect, useState } from 'react';
import { CommonDate, ListDate } from 'services/commonDate_services';
import CloseIcon from '@mui/icons-material/Close';
import { TbExchange, TbLoaderQuarter } from 'react-icons/tb';
import { Autocomplete, Box, Tab, Tabs, TextField } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { AiFillCaretDown, AiOutlineMinus } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import { BC05, BC05Details, ListKeynValue } from 'services/report_services';
import * as rootStore from 'stores/root_store';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { TiArrowUnsorted } from 'react-icons/ti';
import ReactTooltip from 'react-tooltip';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import Pagination from 'base/ui/components/Pagination/pagination';
import SearchCollapse from '../reportComponents/searchCollapse';
import { Button } from 'antd';

const Style = {
  MuiTableCellRoot: {
    fontSize: '13px',
    fontWeight: 700,
    padding: '5px 10px',
    lineHeight: '20px',
    color: 'white',
  },
  '.MuiOutlinedInput-root': {
    padding: 0,
  },
  '.MuiOutlinedInput-input': {
    fontSize: '13px',
  },
  '.MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
  '.css-13xfq8m-MuiTabPanel-root': {
    padding: '5px !important',
  },
  '.css-tqw3aj .css-13xfq8m-MuiTabPanel-root': {
    padding: 5,
  },
};
export function createProductionTime() {
  return observer(() => {
    const columnName = [
      {
        columnName: 'STT',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
      {
        columnName: 'LSX tổng hợp',
        align: 'text-center',
        style: '',
        visible: true,
        key: 'woGeneral',
      },
      {
        columnName: 'LSX',
        align: 'text-center',
        style: '',
        visible: true,
        key: 'workOrderCode',
      },
      {
        columnName: 'TP/BTP',
        align: 'text-center',
        style: '',
        visible: true,
        key: 'productCode',
      },

      {
        columnName: 'Sản lượng KH',
        align: 'text-center',
        style: '',
        visible: true,
        key: 'plannedOutput',
      },
      {
        columnName: 'Sản lượng TT',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
      {
        columnName: 'ĐVT',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
      {
        columnName: 'Tỉ lệ HT',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
      {
        columnName: 'TG SX KH (giờ)',
        align: 'text-center',
        style: '',
        visible: true,
        key: 'planTime',
      },
      {
        columnName: 'TG SX TT (giờ)',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
      {
        columnName: 'TG chênh lệch (giờ)',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
      {
        columnName: '#',
        align: 'text-center',
        style: '',
        visible: true,
        key: '',
      },
    ];
    const columnNameDetalsPopup = [
      {
        columnName: 'STT',
        align: 'text-center',
        style: '',
        visible: true,
      },
      {
        columnName: 'Công đoạn',
        align: 'text-center',
        style: '',
        visible: true,
      },
      {
        columnName: 'Sản lượng KH',
        align: 'text-center',
        style: '',
        visible: true,
      },
      {
        columnName: 'Sản lượng TT',
        align: 'text-center',
        style: '',
        visible: true,
      },
      {
        columnName: 'ĐVT',
        align: 'text-center',
        style: '',
        visible: true,
      },
      {
        columnName: 'Tỉ lệ HT',
        align: 'text-center',
        style: '',
        visible: true,
      },
      {
        columnName: 'TG SX KH (giờ) ',
        align: 'text-center',
        style: '',
        visible: true,
      },

      {
        columnName: 'TG SX TT (giờ)',
        align: 'text-center',
        style: '',
        visible: true,
      },

      {
        columnName: 'TG Chênh lệch (giờ)',
        align: 'text-center',
        style: '',
        visible: true,
      },
    ];
    //=======================================================================
    //======================================================================= REGISTER VARIALBE ZONE
    //=======================================================================
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<String>();
    //loading page when reload
    const [isLoading, setIsLoading] = useState(false);
    // list date
    // OPEN POP UP DIALOG
    const [open, setOpen] = useState(false);
    // mở from search
    const [openSearchBox, setOpenSearchBox] = useState(false);
    // tim kiem LSX TH
    const [wSId, setWSId] = useState<string | null>(null);

    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);
    //lay picked date
    const [pickedDate, setpickedDate] = useState<string>('');
    const [date, setDate] = useState<CommonDate | null>(null);
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    // value of tab index
    // sort
    const [sortUp, setSortUp] = useState(false);
    //index sort
    const [indexSort, setIndexSort] = useState<number | null>(null);
    // value sort
    const [valueSort, setValueSort] = useState<string | null>(null);
    const [value, setValue] = useState('0');

    const [convertToMin, setConvertToMin] = useState(false);
    // số lượng items trên 1 trang
    const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
    // current page
    const [pageIndex, setPageIndex] = useState(1);

    // data
    const [dataAPI, setDataAPI] = useState<BC05[]>();

    // danh sach LSX
    const [listLSX, setListLSX] = useState<ListKeynValue[]>([]);

    // danh sach LSX
    const [listTP_BTP, setListTP_BTP] = useState<ListKeynValue[]>([]);
    // lay lsx
    const [lsx, setLSX] = useState<string[]>([]);
    // lay TP_BTP
    const [tP_BTP, setTP_BTP] = useState<string[]>([]);

    // data
    const [dataPopupAPI, setDataPopUpAPI] = useState<BC05Details[]>([]);

    // thong tin hang tong cong trong pop up
    const [sumPopup, setSumPopup] = useState({ kh: 0, tt: 0 });

    //=======================================================================
    //======================================================================= HANDLE ZONE
    //=======================================================================
    const handleChangeKeyWord = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      await rootStore.reportPresenter.getDropdownWo(rootStore.reportStore, e.target.value);
      setListLSX(rootStore.reportStore.listKeynValue.data);
    };
    const handleChangeKeyWordTP_BTP = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      await rootStore.commonDatePresenter.getListDropdownProduct(rootStore.commonDateStore, e.target.value);
      setListTP_BTP(rootStore.commonDateStore.listDropdownProduct);
    };

    // event change list LSX in search
    const handleChangeListLSX = async (e: SyntheticEvent<Element, Event>, items: ListKeynValue[]) => {
      if (items) {
        const listItem = items.map((item) => {
          return item.key;
        });
        if (listItem) {
          setLSX(listItem);
        }
      }
    };
    const handleChangeListTP_BTP = async (e: SyntheticEvent<Element, Event>, items: ListKeynValue[]) => {
      if (items) {
        const listItem = items.map((item) => {
          return item.key;
        });
        if (listItem) {
          setTP_BTP(listItem);
        }
      }
    };

    // change page size
    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setPageIndex(1);
      setPageSize(parseInt(e.target.value));
    };
    // change page index
    const handleChangePageIndex = (data: any) => {
      setPageIndex(data.selected + 1);
    };

    // FOR SORT TABLE : SẮP XẾP THEO CỘT TRONG BẢNG
    const handleSort = (index: number, value: string) => {
      if (indexSort !== index) setSortUp(true);
      else setSortUp(!sortUp);
      setIndexSort(index);
      setValueSort(value);
    };

    // THAY ĐỔI TAB TỪ BẢNG SANG SƠ ĐỒ
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue);
    };

    // HANDLE CLOSE POP UP EDIT NAME
    const handleClose = () => {
      setOpen(false);
    };

    const handleOnClickOpen = (item: BC05) => {
      setValue('0');
      setOpen(true);
      const getBC05Details = async () => {
        await rootStore.reportPresenter.getBC05Details(rootStore.reportStore, item.workOrderId);
        let sumkh = 0;
        let sumtt = 0;
        rootStore.reportStore.BC05DetailsResponse.data?.slice(0, 1).map((item) => {
          item.header.detail.map((it) => {
            sumkh += it.planTime;
            sumtt += it.actualTime;
          });
        });
        setSumPopup({ kh: sumkh, tt: sumtt });
        setDataPopUpAPI(rootStore.reportStore.BC05DetailsResponse.data);
      };
      getBC05Details();
    };

    // handle search form
    const onSearch = async () => {
      setIsLoading(true);
      await rootStore.reportPresenter.getBC05(rootStore.reportStore, {
        paging: {
          pageSize: pageSize,
          pageIndex: 1,
        },
        woGeneral: wSId,
        workOrderCode: lsx,
        productCode: tP_BTP,
        createTimeWOFrom:
          dateFrom !== ''
            ? dateFrom
            : rootStore.commonDateStore.commonDate.fromDate
              ? rootStore.commonDateStore.commonDate.fromDate
              : null,
        createTimeWOTo:
          dateTo !== ''
            ? dateTo
            : rootStore.commonDateStore.commonDate.toDate
              ? rootStore.commonDateStore.commonDate.toDate
              : null,
      });
      setDataAPI(rootStore.reportStore.BC05Response.data);
      setIsLoading(false);
    };

    const handleChangeListTime = async (e: React.SyntheticEvent<Element, Event>, value: ListDate | null) => {
      if (value && value.key !== 'Custom') {
        setpickedDate(value.key);
        await rootStore.commonDatePresenter.getDataByCommonDate(rootStore.commonDateStore, value.key);
        setDateFrom(rootStore.commonDateStore.commonDate.fromDate);
        setDateTo(rootStore.commonDateStore.commonDate.toDate);
      } else {
        setpickedDate('');
        setDateFrom('');
        setDateTo('');
      }
    };
    //=======================================================================
    //======================================================================= USEFFECT ZONE
    //=======================================================================
    useEffect(() => {
      const getDate = async () => {
        await rootStore.commonDatePresenter.getDataByCommonDate(rootStore.commonDateStore, pickedDate);

        setDate(rootStore.commonDateStore.commonDate);
      };
      getDate();
    }, [pickedDate]);

    useEffect(() => {
      setIsLoading(true);
      const getTimeMachineTroubledReport = async () => {
        if (sortUp === true) {
          await rootStore.reportPresenter.getBC05(rootStore.reportStore, {
            paging: {
              pageSize: pageSize,
              pageIndex: pageIndex,
              orderBy: valueSort,
            },
            woGeneral: wSId,
            workOrderCode: lsx,
            productCode: tP_BTP,
            createTimeWOFrom:
              dateFrom !== ''
                ? dateFrom
                : rootStore.commonDateStore.commonDate.fromDate
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : null,
            createTimeWOTo:
              dateTo !== ''
                ? dateTo
                : rootStore.commonDateStore.commonDate.toDate
                  ? rootStore.commonDateStore.commonDate.toDate
                  : null,
          });
          setDataAPI(rootStore.reportStore.BC05Response.data);
          setIsLoading(false);
        } else if (sortUp === false) {
          await rootStore.reportPresenter.getBC05(rootStore.reportStore, {
            paging: {
              pageSize: pageSize,
              pageIndex: pageIndex,
              orderByDesc: valueSort,
            },
            woGeneral: wSId,
            workOrderCode: lsx,
            productCode: tP_BTP,
            createTimeWOFrom:
              dateFrom !== ''
                ? dateFrom
                : rootStore.commonDateStore.commonDate.fromDate
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : null,
            createTimeWOTo:
              dateTo !== ''
                ? dateTo
                : rootStore.commonDateStore.commonDate.toDate
                  ? rootStore.commonDateStore.commonDate.toDate
                  : null,
          });
          setDataAPI(rootStore.reportStore.BC05Response.data);
          setIsLoading(false);
        }
      };
      getTimeMachineTroubledReport();
    }, [indexSort, sortUp]);

    useEffect(() => {
      const getDateCommon = async () => {
        setIsLoading(true);
        await rootStore.commonDatePresenter.getListCommonDate(rootStore.commonDateStore);
        await rootStore.reportPresenter.getBC05(rootStore.reportStore, {
          paging: {
            pageSize: pageSize,
            pageIndex: pageIndex,
          },
          woGeneral: wSId,
          workOrderCode: lsx,
          productCode: tP_BTP,
          createTimeWOFrom:
            dateFrom !== ''
              ? dateFrom
              : rootStore.commonDateStore.commonDate.fromDate
                ? rootStore.commonDateStore.commonDate.fromDate
                : null,
          createTimeWOTo:
            dateTo !== ''
              ? dateTo
              : rootStore.commonDateStore.commonDate.toDate
                ? rootStore.commonDateStore.commonDate.toDate
                : null,
        });
        setDataAPI(rootStore.reportStore.BC05Response.data);
        setCommonDate(rootStore.commonDateStore.listDate.data);
        setIsLoading(false);
      };
      getDateCommon();

      const getWoCode = async () => {
        await rootStore.reportPresenter.getDropdownWo(rootStore.reportStore, '');
        setListLSX(rootStore.reportStore.listKeynValue.data);
      };
      getWoCode();

      const getListDropdownProduct = async () => {
        await rootStore.commonDatePresenter.getListDropdownProduct(rootStore.commonDateStore, '');
        setListTP_BTP(rootStore.commonDateStore.listDropdownProduct);
      };
      getListDropdownProduct();
    }, []);

    const convertToMinFromhour = (item: number) => {
      let h = Math.round(Math.abs(item)) > 0 ? Math.floor(Math.abs(item)).toLocaleString() + ' giờ ' : '';

      let m =
        h === ''
          ? Math.round((Math.abs(item) * 60) % 60) + ' phút'
          : Math.round(Math.abs(item) * 60) % 60 > 0
            ? Math.round((Math.abs(item) * 60) % 60) + ' phút'
            : '';
      return h + m;
    };

    useEffect(() => {
      const getBC05 = async () => {
        setIsLoading(true);
        await rootStore.reportPresenter.getBC05(rootStore.reportStore, {
          paging: {
            pageSize: pageSize,
            pageIndex: pageIndex,
          },
          woGeneral: wSId,
          workOrderCode: lsx,
          productCode: tP_BTP,
          createTimeWOFrom:
            dateFrom !== ''
              ? dateFrom
              : rootStore.commonDateStore.commonDate.fromDate
                ? rootStore.commonDateStore.commonDate.fromDate
                : null,
          createTimeWOTo:
            dateTo !== ''
              ? dateTo
              : rootStore.commonDateStore.commonDate.toDate
                ? rootStore.commonDateStore.commonDate.toDate
                : null,
        });
        setDataAPI(rootStore.reportStore.BC05Response.data);
        setIsLoading(false);
      };
      getBC05();
    }, [pageSize, pageIndex]);

    //=======================================================================
    //======================================================================= RETURN ZONE
    //=======================================================================
    return (
      <div className="py-3 px-5">
        <SearchCollapse title="BC05. BÁO CÁO SẢN LƯỢNG & THỜI GIAN SẢN XUẤT THỰC TẾ/KẾ HOẠCH">
          <form onSubmit={handleSubmit(onSearch)} className="w-full px-8  py-2 lg:grid lg:grid-cols-2 flex flex-col">
            {/* Chọn LSX tổng hợp */}
            <div className="w-full mb-2 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">LSX tổng hợp</label>

              <input
                onChange={(e) => setWSId(e.target.value)}
                className="col-span-2 text-gray-700 border border-border_input sm:ml-5 p-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                placeholder="Nhập LSX tổng hợp..."
              />
            </div>
            <div></div>

            {/* Chọn LSX */}
            <div className="w-full  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Lệnh sản xuất</label>
              <Autocomplete
                disableCloseOnSelect
                multiple
                sx={Style}
                classes={{ listbox: 'text-default' }}
                className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-gray-300 border-gray-300 sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="checkboxes-tags-demo"
                options={listLSX}
                // @ts-ignore
                onChange={handleChangeListLSX}
                getOptionLabel={(option) => option.value}
                renderOption={(props, option, { selected }) => <li {...props}>{option.value}</li>}
                renderInput={(params) => (
                  <TextField {...params} onChange={handleChangeKeyWord} placeholder="Chọn lệnh sản xuất" />
                )}
              />
            </div>
            {/* Chọn TP/BTP */}
            <div className="w-full  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">TP/BTP</label>
              <Autocomplete
                disableCloseOnSelect
                multiple
                sx={Style}
                classes={{ listbox: 'text-default' }}
                className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-gray-300 border-gray-300 sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="checkboxes-tags-demo"
                options={listTP_BTP}
                onChange={handleChangeListTP_BTP}
                getOptionLabel={(option) => option.value}
                renderOption={(props, option, { selected }) => <li {...props}>{option.value}</li>}
                renderInput={(params) => (
                  <TextField {...params} onChange={handleChangeKeyWordTP_BTP} placeholder="Chọn TP/BTP..." />
                )}
              />
            </div>

            {/* Chọn Ngày phát lệnh */}
            <div className="w-full  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Ngày phát lệnh</label>
              <Autocomplete
                sx={Style}
                classes={{ listbox: 'text-default' }}
                className="col-span-2 text-gray-700 p-0 text-default hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-gray-300 sm:ml-5 py-1.5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="checkboxes-tags-demo"
                options={commonDate}
                defaultValue={{
                  key: '',
                  value: '',
                }}
                onChange={handleChangeListTime}
                getOptionLabel={(option) => option.value}
                renderOption={(props, option, { selected }) => <li {...props}>{option.value}</li>}
                renderInput={(params) => <TextField {...params} placeholder="Chọn khoảng thời gian" />}
              />
            </div>
            <div></div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Từ ngày</label>
              <input
                // {...register('estimateFromDateFrom')}
                type="date"
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={date?.fromDate || dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Đến ngày</label>
              <input
                // {...register('estimateFromDateTo')}
                type="date"
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={date?.toDate || dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>

            {/* button tìm kiếm */}
            <div className="mt-2 w-full flex justify-center col-span-2">
              <Button
                type="primary"
                loading={isLoading}
                htmlType="submit"
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </form>
        </SearchCollapse>

        <div className="w-full bg-white p-3 rounded border border-neutral-300">
          <Pagination
            pageCount={rootStore.reportStore.BC05Response.pagesCount}
            // hiddenPageSize
            forcePage={pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />
          {/* =========== Table PO ===============*/}
          <div className={`overflow-x-auto flex justify-center my-3`}>
            <table className="w-full table-auto border">
              <thead className="font-medium text-white bg-[#4682B4]">
                <tr>
                  {columnName?.map((item, index) => {
                    if (item.visible) {
                      return (
                        <th
                          key={index}
                          onClick={() => item.key && handleSort(index, item.key ? item.key : '')}
                          scope="col"
                          className={`
                            ${item.visible ? '' : 'hidden'} ${item.style} 
                            
                          border border-collapse cursor-pointer text-default font-[550] p-2  text-white bg-[#4682B4] items-center
                          `}
                        >
                          <div className="flex items-center justify-center">
                            {item.key ? (
                              <div className="flex items-center justify-center">
                                <span>{item.columnName}</span>
                                {indexSort !== index && item.key && (
                                  <span className="float-right">
                                    <TiArrowUnsorted className="!text-default" />
                                  </span>
                                )}
                                {indexSort == index && item.key && (
                                  <AiFillCaretDown
                                    className={`text-default min-w-[13px] ml-2 ${sortUp ? '' : 'rotate-180'
                                      } duration-100`}
                                  />
                                )}
                              </div>
                            ) : (
                              <div className="flex items-center justify-center">{item.columnName}</div>
                            )}
                          </div>
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {(dataAPI?.length as Number) ? (
                  dataAPI?.map((item, index) => {
                    return (
                      <tr className="cursor-pointer text-default " key={index}>
                        <td className="border p-1 text-center">{item.stt}</td>
                        <td className="border p-1 text-left">{item.woGeneral}</td>
                        <td className="border p-1 text-left">{item.workOrderCode}</td>
                        <td className="border p-1 text-left">{item.productCode + ' | ' + item.productName}</td>
                        <td className="border p-1 text-right">{item.plannedOutput?.toLocaleString()}</td>
                        <td className="border p-1 text-right">{item.actualOutput?.toLocaleString()}</td>
                        <td className="border p-1 text-left">{item.unit}</td>
                        <td className="border p-1 text-right">
                          {item.percentComplete?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) + ' %'}
                        </td>
                        <td className="border p-1 text-right">
                          {item.planTime?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="border p-1 text-right">
                          {item.actualTime?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="border p-1 text-right">
                          {item.timeDifference?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td
                          className="border p-1 text-center underline hover:text-blue-500"
                          onClick={() => handleOnClickOpen(item)}
                        >
                          <VisibilityIcon className="text-blue-500 hover:text-blue-700" />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="border whitespace-nowrap p-1.5 text-default text-center" colSpan={100}>
                      Không tìm thấy dữ liệu
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <Pagination
            pageCount={rootStore.reportStore.BC05Response.pagesCount}
            hiddenPageSize
            forcePage={pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          /> */}
          <span className="block my-4 text-default text-right">
            Đang xem từ {`${dataAPI && dataAPI.length ? dataAPI[0]?.stt : 0}`} đến {`${dataAPI && dataAPI.length ? dataAPI[dataAPI.length - 1]?.stt : 0}`} trong tổng số{' '}
            {`${rootStore.reportStore.BC05Response.recordsTotal || 0}`} mục
          </span>
        </div>
        {/* pop up */}
        <div
          className={`fixed w-auto max-w-4xl min-w-[65%] bg-white top-1/2 left-1/2 
          -translate-y-1/2 -translate-x-1/2 shadow-xl p-2 
          shadow-modal text-default rounded border-t-2 border-t-sky-700 ${!open && 'hidden'}`}
        >
          <div className="flex justify-end mb-3">
            <button
              type="button"
              onClick={handleClose}
              className="rounded-sm text-white bg-red-400 hover:bg-red-400/90 h-[20px] w-[20px]"
            >
              <CloseIcon className="!flex !h-[20px] !w-[20px]" />
            </button>
          </div>
          <Box sx={Style} className="bg-white w-full ">
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  variant="scrollable"
                  scrollButtons="auto"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  {dataPopupAPI.map((item, index) => {
                    return <Tab defaultValue={3} key={index} label={item.numberPallet} value={index.toString()} />;
                  })}
                </TabList>
              </Box>
              {dataPopupAPI.map((item, index) => {
                return (
                  <TabPanel key={index} value={index.toString()}>
                    <div className="w-full bg-white py-3 px-1 rounded border border-neutral-300">
                      <div className="">
                        <div className=" flex flex-col">
                          <span className="p-1 px-3 font-medium text-default mb-2 bg-blue-500 text-white ">HEADER</span>
                          <div className="mt-2">
                            <div className=" grid grid-cols-2">
                              <div className="col-span-1 grid grid-cols-3">
                                <div className="flex items-center justify-end col-span-1 p-2 text-right font-semibold border text-default bg-gray-100">
                                  LSX tổng hợp
                                </div>
                                <div className=" col-span-2 flex items-center p-2 text-left font-normal border text-default">
                                  {item.header.woGeneral}
                                </div>
                              </div>
                              <div className="grid grid-cols-3">
                                <div className="flex items-center justify-end col-span-1 p-2 text-right font-semibold border text-default bg-gray-100">
                                  Số thẻ treo
                                </div>
                                <div className=" col-span-2 flex items-center p-2 text-left font-normal border text-default">
                                  {item.header.numberPallet}
                                </div>
                              </div>
                            </div>
                            <div className=" grid grid-cols-2">
                              <div className="col-span-1 grid grid-cols-3">
                                <div className="flex items-center justify-end col-span-1 p-2 text-right font-semibold border text-default bg-gray-100">
                                  LSX
                                </div>
                                <div className="col-span-2 flex items-center p-2 text-left font-normal border text-default">
                                  {item.header.workOrderCode}
                                </div>
                              </div>
                              <div className="grid grid-cols-3">
                                <div className="flex items-center justify-end col-span-1 p-2 text-right font-semibold border text-default bg-gray-100">
                                  SL trên thẻ treo
                                </div>
                                <div className="col-span-2 flex items-center  p-2 text-left font-normal border text-default">
                                  {item.header.quantityByPallet?.toLocaleString() + ' Hộp'}
                                </div>
                              </div>
                            </div>
                            <div className=" grid grid-cols-2">
                              <div className="col-span-1 grid grid-cols-3">
                                <div className="flex items-center justify-end col-span-1 p-2 font-semibold border text-default bg-gray-100">
                                  TP/BTP
                                </div>
                                <div className="flex items-center col-span-2 p-2 text-left font-normal border text-default">
                                  {item.header.productName}
                                </div>
                              </div>
                              <div className="grid grid-cols-3">
                                <div className="flex items-center justify-end col-span-1 p-2 text-right font-semibold border text-default bg-gray-100">
                                  SL phát lệnh
                                </div>
                                <div className="flex items-center col-span-2 p-2 text-left font-normal border text-default">
                                  {item.header.quantityOrder?.toLocaleString() + ' Hộp'}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className=" mt-10 flex justify-center flex-col ">
                          <div className="grid grid-cols-5 p-1 relative px-3 font-medium text-default mb-2 bg-blue-500 text-white">
                            <div className=" col-span-4  ">DETAILS </div>
                            <button
                              onClick={() => setConvertToMin(!convertToMin)}
                              className="flex justify-center border border-blue-500  hover:border-white"
                              data-tip
                              data-for="buttonTipFrom"
                            >
                              <TbExchange className="inline-block pl-1 text-2xl" />
                            </button>

                            <ReactTooltip id="buttonTipFrom" place="left" effect="float">
                              Đổi giờ sang phút
                            </ReactTooltip>
                          </div>

                          <table className="mt-2">
                            <thead className="text-white bg-[#4682B4]">
                              <tr>
                                {columnNameDetalsPopup.map((ite, ind) => {
                                  return (
                                    <th
                                      key={ind}
                                      className={`${ite.align} ${ite.style} p-2 text-left font-semibold border text-default`}
                                    >
                                      {ite.columnName}
                                    </th>
                                  );
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {item.header.detail.map((it, id) => {
                                return (
                                  <tr key={id} className="border">
                                    <td className="border p-1 text-center">{id}</td>
                                    <td className="border p-1 text-left">{it.stepCode}</td>
                                    <td className="border p-1 text-right">{it.plannedOutput.toLocaleString()}</td>
                                    <td className="border p-1 text-right">{it.actualOutput.toLocaleString()}</td>
                                    <td className="border p-1 text-left">{it.unit}</td>
                                    <td className="border p-1 text-right">
                                      {it.percentComplete
                                        ? it.percentComplete?.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }) + '%'
                                        : ''}
                                    </td>
                                    <td className="border p-1 text-right">
                                      {convertToMin
                                        ? convertToMinFromhour(it.planTime)
                                        : it.planTime?.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                    </td>
                                    <td className="border p-1 text-right">
                                      {convertToMin
                                        ? convertToMinFromhour(it.actualTime)
                                        : it.actualTime?.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                    </td>
                                    <td
                                      className={`border p-1 text-right font-bold ${it.timeDifference > 0
                                          ? 'text-red-500'
                                          : it.timeDifference < 0
                                            ? 'text-green-700'
                                            : ''
                                        }`}
                                    >
                                      {convertToMin
                                        ? convertToMinFromhour(it.timeDifference)
                                        : Math.abs(it.timeDifference)?.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                    </td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td className="border p-1 text-right font-bold" colSpan={6}>
                                  Tổng
                                </td>
                                <td className="border p-1 text-right font-bold">
                                  {convertToMin
                                    ? convertToMinFromhour(sumPopup.kh)
                                    : sumPopup.kh?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                </td>
                                <td className="border p-1 text-right font-bold">
                                  {convertToMin
                                    ? convertToMinFromhour(sumPopup.tt)
                                    : sumPopup.tt?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                </td>
                                <td
                                  className={`border p-1 text-right font-bold ${sumPopup.kh - sumPopup.tt > 0
                                      ? 'text-green-700'
                                      : sumPopup.kh - sumPopup.tt < 0
                                        ? 'text-red-500'
                                        : ''
                                    } `}
                                >
                                  {convertToMin
                                    ? convertToMinFromhour(sumPopup.kh - sumPopup.tt)
                                    : Math.abs(sumPopup.kh - sumPopup.tt)?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                );
              })}
            </TabContext>
          </Box>
        </div>
      </div>
    );
  });
}
